import ruzbeh_bacha from '../../assets/about/about_us_profiles/ruzbeh.jpg';
import happy_ruzbeh_bacha from '../../assets/about/about_us_profiles/ruzbeh-hover.jpg';
import taras_chemeris from '../../assets/about/about_us_profiles/taras.jpg';
import happy_taras_chemeris from '../../assets/about/about_us_profiles/taras-hover.jpg';
import artem from '../../assets/about/about_us_profiles/artem.jpg';
import happy_artem from '../../assets/about/about_us_profiles/artem-hover.jpg';
import cory from '../../assets/about/about_us_profiles/cory.jpg';
import happy_cory from '../../assets/about/about_us_profiles/cory-hover.jpg';
import daria_shvedova from '../../assets/about/about_us_profiles/daria.jpg';
import happy_daria_shvedova from '../../assets/about/about_us_profiles/daria-hover.jpg';
import liuba_detiatkina from '../../assets/about/about_us_profiles/luba.jpg';
import happy_liuba_detiatkina from '../../assets/about/about_us_profiles/luba-hover.jpg';

import igor_mishkovski from '../../assets/about/about_us_profiles/igor.jpg';
import happy_igor_mishkovski from '../../assets/about/about_us_profiles/igor-hover.jpg';
import inderjit from '../../assets/about/about_us_profiles/inderjit.jpg';
import happy_inderjit from '../../assets/about/about_us_profiles/inderjit-hover.jpg';
import andrei_volyk from '../../assets/about/about_us_profiles/andrey-v.jpg';
import happy_andrei_volyk from '../../assets/about/about_us_profiles/andrey-v-hover.jpg';
import sujeet_s from '../../assets/about/about_us_profiles/sujeet-s.jpg';
import happy_sujeet_s from '../../assets/about/about_us_profiles/sujeet-s-hover.png';
import maulik from '../../assets/about/about_us_profiles/maulik.jpg';
import happy_maulik from '../../assets/about/about_us_profiles/maulik-hover.jpg';
import sargis_shahinyan from '../../assets/about/about_us_profiles/sargis.jpg';
import happy_sargis_shahinyan from '../../assets/about/about_us_profiles/sargis-hover.jpg';
import akshay from '../../assets/about/about_us_profiles/akshay.jpg';
import happy_akshay from '../../assets/about/about_us_profiles/akshay-hover.jpg';
import vivek from '../../assets/about/about_us_profiles/vivek.jpg';
import happy_vivek from '../../assets/about/about_us_profiles/vivek-hover.jpg';
import kyrylo from '../../assets/about/about_us_profiles/kyrylo.png';
import happyKyrylo from '../../assets/about/about_us_profiles/kyrylo-hover.png';

import kash from '../../assets/about/about_us_profiles/kash.jpg';
import happy_kash from '../../assets/about/about_us_profiles/kash-hover.jpg';
import katerina from '../../assets/about/about_us_profiles/katerina.jpg';
import happy_katerina from '../../assets/about/about_us_profiles/katerina-hover.jpg';
import lidiia from '../../assets/about/about_us_profiles/lidiia.jpg';
import happy_lidiia from '../../assets/about/about_us_profiles/lidiia-hover.jpg';
import yuris from '../../assets/about/about_us_profiles/yuris.jpg';
import happy_yuris from '../../assets/about/about_us_profiles/yuris-hover.jpg';
import argyris from '../../assets/about/about_us_profiles/argyris.png';
import happyArgyris from '../../assets/about/about_us_profiles/argyris-hover.png';
import iryna from '../../assets/about/about_us_profiles/iryna.png';
import happyIryna from '../../assets/about/about_us_profiles/iryna-hover.png';

import ivan from '../../assets/about/about_us_profiles/ivan.jpg';
import happy_ivan from '../../assets/about/about_us_profiles/ivan-hover.jpg';

import sarvjeet from '../../assets/about/about_us_profiles/sarvjeet.jpg';
import happy_sarvjeet from '../../assets/about/about_us_profiles/sarvjeet-hover.jpg';
import kate from '../../assets/about/about_us_profiles/kate.jpg';
import happy_kate from '../../assets/about/about_us_profiles/kate-hover.jpg';
import nik from '../../assets/about/about_us_profiles/nik.jpg';
import happy_nik from '../../assets/about/about_us_profiles/nik-hover.jpg';

import jitendra from '../../assets/about/about_us_profiles/jitendra.jpg';
import happy_jitendra from '../../assets/about/about_us_profiles/jitendra-hover.jpg';
import bojana_pm from '../../assets/about/about_us_profiles/bojana-pm.jpg';
import happy_bojana_pm from '../../assets/about/about_us_profiles/bojana-pm-hover.jpg';

import ivan_krstev from '../../assets/about/about_us_profiles/ivan-krstev-data-scientist.jpg';
import happy_ivan_krstev from '../../assets/about/about_us_profiles/ivan-krstev-data-scientist-hover.jpg';
import dmytro_shklianka from '../../assets/about/about_us_profiles/dmytro-shklianka-fe-dev.jpg';
import happy_dmytro_shklianka from '../../assets/about/about_us_profiles/dmytro-shklianka-fe-dev-hover.jpg';
import happy_pavlo_holodnikov from '../../assets/about/about_us_profiles/pavlo-holodnikov-qa-hover.jpg';
import pavlo_holodnikov from '../../assets/about/about_us_profiles/pavlo-holodnikov-qa.jpg';
import happy_ihor_kondrashov from '../../assets/about/about_us_profiles/ihor-kondrashov-qa-hover.jpg';
import ihor_kondrashov from '../../assets/about/about_us_profiles/ihor-kondrashov-qa.jpg';
import happy_dimitris_koutsoumpos from '../../assets/about/about_us_profiles/dimitris-koutsoumpos-fa-hover.jpg';
import dimitris_koutsoumpos from '../../assets/about/about_us_profiles/dimitris-koutsoumpos-fa.jpg';

export const TEAMMATES = {
  managementTeam: {
    firstRow:
      [
        { general: ruzbeh_bacha, happy: happy_ruzbeh_bacha },
        { general: taras_chemeris, happy: happy_taras_chemeris },
        { general: cory, happy: happy_cory },
      ],
    secondRow:
      [
        { general: bojana_pm, happy: happy_bojana_pm },
        { general: liuba_detiatkina, happy: happy_liuba_detiatkina },
        { general: artem, happy: happy_artem },
      ],
  },
  developersTeam: {
    firstRow:
      [
        { general: igor_mishkovski, happy: happy_igor_mishkovski },
        { general: andrei_volyk, happy: happy_andrei_volyk },
        { general: inderjit, happy: happy_inderjit },
        { general: vivek, happy: happy_vivek },
      ],
    secondRow:
      [
        { general: kyrylo, happy: happyKyrylo },
        { general: sargis_shahinyan, happy: happy_sargis_shahinyan },
        { general: akshay, happy: happy_akshay },
        { general: sujeet_s, happy: happy_sujeet_s },
      ],
    thirdRow:
      [
        { general: maulik, happy: happy_maulik },
        { general: ivan_krstev, happy: happy_ivan_krstev },
        { general: dmytro_shklianka, happy: happy_dmytro_shklianka },
      ],
  },
  financialTeam: {
    firstRow:
      [
        { general: kash, happy: happy_kash },
        { general: dimitris_koutsoumpos, happy: happy_dimitris_koutsoumpos },
        { general: argyris, happy: happyArgyris },
      ],
    secondRow:
      [
        { general: iryna, happy: happyIryna },
        { general: lidiia, happy: happy_lidiia },
        { general: yuris, happy: happy_yuris },
      ],
  },
  designersTeam: {
    firstRow:
      [
        { general: ivan, happy: happy_ivan },
        { general: daria_shvedova, happy: happy_daria_shvedova },
      ],
  },
  qasTeam: {
    firstRow:
      [
        { general: kate, happy: happy_kate },
        { general: nik, happy: happy_nik },
        { general: katerina, happy: happy_katerina },
        { general: jitendra, happy: happy_jitendra },
      ],
    secondRow:
      [
        { general: sarvjeet, happy: happy_sarvjeet },
        { general: pavlo_holodnikov, happy: happy_pavlo_holodnikov },
        { general: ihor_kondrashov, happy: happy_ihor_kondrashov },
      ],
  },
};

export const TEAMMATES_MOBILE = {
  managementTeam: {
    firstRow:
      [
        { general: ruzbeh_bacha, happy: happy_ruzbeh_bacha },
        { general: taras_chemeris, happy: happy_taras_chemeris },
        { general: cory, happy: happy_cory },

      ],
    secondRow:
      [
        { general: bojana_pm, happy: happy_bojana_pm },
        { general: liuba_detiatkina, happy: happy_liuba_detiatkina },
        { general: artem, happy: happy_artem },
      ],
  },
  developersTeam: {
    firstRow:
      [
        { general: igor_mishkovski, happy: happy_igor_mishkovski },
        { general: andrei_volyk, happy: happy_andrei_volyk },
        { general: inderjit, happy: happy_inderjit },
      ],
    secondRow:
      [
        { general: kyrylo, happy: happyKyrylo },
        { general: vivek, happy: happy_vivek },
        { general: sargis_shahinyan, happy: happy_sargis_shahinyan },
      ],
    thirdRow:
      [
        { general: akshay, happy: happy_akshay },
        { general: sujeet_s, happy: happy_sujeet_s },
        { general: maulik, happy: happy_maulik },
      ],
    fourthRow:
      [
        { general: ivan_krstev, happy: happy_ivan_krstev },
        { general: dmytro_shklianka, happy: happy_dmytro_shklianka },
      ],
  },
  financialTeam: {
    firstRow:
      [
        { general: kash, happy: happy_kash },
        { general: dimitris_koutsoumpos, happy: happy_dimitris_koutsoumpos },
        { general: argyris, happy: happyArgyris },
      ],
    secondRow:
      [
        { general: iryna, happy: happyIryna },
        { general: lidiia, happy: happy_lidiia },
        { general: yuris, happy: happy_yuris },
      ],
    thirdRow:
      [],
  },
  designersTeam: {
    firstRow:
      [
        { general: ivan, happy: happy_ivan },
        { general: daria_shvedova, happy: happy_daria_shvedova },
      ],
  },
  qasTeam: {
    firstRow:
      [
        { general: kate, happy: happy_kate },
        { general: nik, happy: happy_nik },
        { general: katerina, happy: happy_katerina },
        { general: jitendra, happy: happy_jitendra },
      ],
    secondRow:
      [
        { general: sarvjeet, happy: happy_sarvjeet },
        { general: pavlo_holodnikov, happy: happy_pavlo_holodnikov },
        { general: ihor_kondrashov, happy: happy_ihor_kondrashov },
      ],
    thirdRow:
      [
      ],
  },
};
